/**
 * クエリパラメータからユーザー一覧のorderingを生成する
 * グループ/タグ抽出: グループ表示優先度（降順） → ユーザー表示優先度（降順）
 * 学年/組抽出: 学年 → 組 → 出席番号 → ユーザー表示優先度（降順）
 * それ以外: 学年 → 組 → 出席番号（フォールバック）
 */
export const buildOrderingByFilterQuery = q => {
  if (q.departments || q.tag1 || q.tag2) return '-department__sort_no,-sort_no'
  if (q.grades || q.homerooms) return 'grade,homeroom,attendance_number,-sort_no'
  return 'grade,homeroom,attendance_number'
}

/**
 * クエリパラメータからAPIメンバーフィルターパラメータを生成する
 * @param {Object} q - クエリパラメータ（URLクエリまたはVuex filterParams）
 * @returns {Object} APIリクエスト用パラメータ
 */
export const buildMemberFilterApiParams = q => {
  const params = {}
  if (q.departments) params.department__in = q.departments
  if (q.tag1) params.tag1__in = q.tag1
  if (q.tag2) params.tag2__in = q.tag2
  if (q.grades) params.grade__in = q.grades
  if (q.homerooms) params.homeroom__in = q.homerooms
  return params
}

/**
 * URLクエリが空の場合はVuex filterParamsを使うクエリ解決
 * @param {Object} routeQuery - this.$route.query
 * @param {Object} filterParams - Vuex の filterParams
 * @returns {Object} 使用するクエリ
 */
export const resolveFilterQuery = (routeQuery, filterParams) => {
  return Object.keys(routeQuery).length > 0 ? routeQuery : filterParams
}
